import React from "react";
import { Row, Col } from "react-bootstrap";
const ImageMessage = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: props.parentClassName },
            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 justify-content-start" }, props.title),
            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "justify-content-center mt-5" },
                React.createElement("img", { src: props.image, className: "mx-auto d-block" })),
            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansN_24_400 text-center mt-30 txt_blackOne1" }, props.message))));
};
export default ImageMessage;
